module.exports = __webpack_public_path__ + "media/images/30px_emptystar-b41577ceb264ce6a9a30e464d1c1de71b745d979c2940fcacfc5695b073046db.png";